import { SelectButton } from "./SelectButton";

const formatOption = (option) => {
  if (option == null || option === undefined) return "";
  
  if (typeof option === "number") {
    return String(option);
  }
  
  if (typeof option === "string") {
    return option
      .split("_")
      .map((word) => {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  }
  
  if (option && typeof option === "object" && option.label && typeof option.label === "string") {
    return option.label
      .split("_")
      .map((word) => {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  }
  
  return String(option || "");
};

export const PitchGrid = ({ options, selected, onChange, disabled }) => {
  if (!options || !Array.isArray(options) || options.length === 0) {
    return null;
  }
  
  const validOptions = options.filter((opt) => opt != null);
  
  if (validOptions.length === 0) {
    return null;
  }
  
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-1 sm:gap-1.5">
      {validOptions.map((option, index) => {
        const key = typeof option === "string" || typeof option === "number" 
          ? option 
          : option?.value || index;
        
        return (
          <SelectButton
            key={key}
            selected={selected === option}
            onClick={() => onChange && onChange(option)}
            disabled={disabled}
          >
            {formatOption(option)}
          </SelectButton>
        );
      })}
    </div>
  );
};
